<div class="menu-wrapper">
  <div class="menu-container">
    <mat-tree
      #menuTree
      [dataSource]="dataSource()"
      [childrenAccessor]="childrenAccessor"
    >
      <mat-tree-node data-cy="menu-tree-e2e" *matTreeNodeDef="let node">
        @if (node.dialogComponentKey) {
          <button
            class="tree-button"
            (click)="openDialog(node.dialogComponentKey)"
          >
            <mat-icon>{{ node.icon || 'circle' }}</mat-icon>
            {{ node.name }}
          </button>
        } @else if (node.router_link) {
          <a
            class="tree-button"
            [routerLink]="getRoutePath(node.router_link)"
            [queryParams]="getRouteQueryParams(node.router_link)"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <mat-icon>{{ node.icon || 'circle' }}</mat-icon>

            {{ node.name }}
          </a>
        }
      </mat-tree-node>
      <mat-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        data-cy="menu-tree-e2e"
        matTreeNodeToggle
        [cdkTreeNodeTypeaheadLabel]="node.name"
        class="expand-button-name-menu-tree"
      >
        <button
          matTreeNodeToggle
          matIconButton
          [attr.aria-label]="'Toggle ' + node.name"
        >
          <mat-icon>
            {{
              menuTree.isExpanded(node)
                ? 'expand_more'
                : node.icon || 'chevron_right'
            }}
          </mat-icon>
        </button>

        {{ node.name }}
      </mat-tree-node>
    </mat-tree>
  </div>
  <div class="shadow shadow-top" aria-hidden="true">
    <mat-icon>expand_less</mat-icon>
  </div>
  <div class="shadow shadow-bottom" aria-hidden="true">
    <mat-icon>expand_more</mat-icon>
  </div>
</div>
